<template>
  <div>
    <div v-show="currentPage === 1">
      <div class="rebalance-calculator">
        <div class="row">
          <div class="col-lg-12">
            <div class="card rebalance-border">
              <div class="card-body">
                <v-form @submit.prevent="submitForm">
                  <div class="d-flex justify-content-between">
                    <div>
                      <h2>Current investments</h2>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4">
                      <div class="rebalance-input">
                        <label for="equity-amount" class="label-spacing"
                          >Equity</label
                        >
                        <span class="rebalance-group">
                          <div class="rupees-symbol">₹</div>
                          <input
                            type="text"
                            class="form-control"
                            v-model="formData.equity"
                            outlined
                            id="equity-amount"
                            placeholder="0"
                          />
                        </span>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="rebalance-input">
                        <label for="debt-amount" class="label-spacing"
                          >Debt</label
                        >
                        <span class="rebalance-group">
                          <div class="rupees-symbol">₹</div>
                          <input
                            class="form-control"
                            type="text"
                            v-model="formData.debt"
                            outlined
                            id="debt-amount"
                            placeholder="0"
                          />
                        </span>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="rebalance-input">
                        <label for="gold-amount" class="label-spacing"
                          >Gold</label
                        >
                        <span class="rebalance-group">
                          <div class="rupees-symbol">₹</div>
                          <input
                            class="form-control"
                            type="text"
                            v-model="formData.gold"
                            outlined
                            id="gold-amount"
                            placeholder="0"
                          />
                        </span>
                      </div>
                    </div>
                    <p class="validate-msg" v-if="!anyFieldNotEmpty">
                      {{ msg }}
                    </p>
                    <div>
                      <h5 style="text-align: start">
                        Current Allocation Percentage
                      </h5>
                    </div>
                    <div class="distribution-bar-container">
                      <div class="row">
                        <div class="col-md-4">
                          <div class="distribution-label">
                            <div class="box1"></div>
                            <label for="distribution-bar"
                              >Equity
                              {{
                                calculatedPercentages.equityPerDisplay
                              }}</label
                            >
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="distribution-label">
                            <div class="box2"></div>
                            <label for="distribution-bar"
                              >Debt
                              {{ calculatedPercentages.debtPerDisplay }}</label
                            >
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="distribution-label">
                            <div class="box3"></div>
                            <label for="distribution-bar"
                              >Gold
                              {{ calculatedPercentages.goldPerDisplay }}</label
                            >
                          </div>
                        </div>
                      </div>
                      <div class="card first-card">
                        <div class="row">
                          <h2>Desired allocation</h2>
                          <div class="col-md-4">
                            <div class="rebalance-input">
                              <label for="equity-percent" class="label-spacing"
                                >Equity Percentage</label
                              >
                              <span class="rebalance-group">
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model="desiredEquityPercent"
                                  outlined
                                  id="equity-percent"
                                  min="0"
                                  max="100"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="rebalance-input">
                              <label for="debt-percent" class="label-spacing"
                                >Debt Percentage</label
                              >
                              <span class="rebalance-group">
                                <input
                                  class="form-control"
                                  type="text"
                                  v-model="desiredDebtPercent"
                                  outlined
                                  id="debt-percent"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="rebalance-input">
                              <label for="gold-percent" class="label-spacing"
                                >Gold Percentage</label
                              >
                              <span class="rebalance-group">
                                <input
                                  class="form-control"
                                  type="text"
                                  v-model="desiredGoldPercent"
                                  outlined
                                  id="gold-percent"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="rebalance-input">
                            <p class="validate-msg">{{ percentMsg }}</p>
                          </div>
                          <div class="row">
                            <div class="col-md-4">
                              <div class="rebalance-input">
                                <label for="fresh-invest" class="label-spacing"
                                  >Fresh Investments, if any</label
                                >
                                <span class="rebalance-group">
                                  <input
                                    class="form-control"
                                    type="text"
                                    v-model="freshInvest"
                                    outlined
                                    id="fresh-invest"
                                  />
                                </span>
                                <i style="font-size: 80%"
                                  >Fresh investments can help you rebalance with
                                  lower redemptions</i
                                >
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="rebalance-input">
                                <label
                                  for="rebalanceThreshold"
                                  class="label-spacing"
                                  >Rebalance threshold</label
                                >
                                <span class="rebalance-group">
                                  <select
                                    id="rebalanceThreshold"
                                    class="form-control"
                                    v-model="reblanceThreshold"
                                    style="background-color: #f8f9fa"
                                    @change="handleRebalanceThresholdChange"
                                  >
                                    <option value="0">Any deviation</option>
                                    <option value="5" selected>5%</option>
                                    <option value="6">6%</option>
                                    <option value="7">7%</option>
                                    <option value="8">8%</option>
                                    <option value="9">9%</option>
                                    <option value="10">10%</option>
                                  </select>
                                </span>
                                <i style="font-size: 80%"
                                  >% of deviation that should cause rebalancing
                                  (5% recommended)</i
                                >
                                <p class="rebalance-thres">
                                  {{ this.thresMsg }}
                                </p>
                              </div>
                            </div>

                            <div
                              class="col-md-4 mb-0"
                              style="align-content: end"
                            >
                              <button
                                type="button"
                                @click="submitForm()"
                                class="rebalance-button"
                              >
                                Calculate
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="currentPage === 2">
      <div class="rebalance-calculator">
        <div class="row">
          <div class="col-lg-12">
            <div class="card rebalance-border">
              <div class="card-body">
                <div class="d-flex justify-content-between">
                  <div></div>
                </div>
                <div>
                  <h2>Portfolio Rebalancing Results</h2>
                  <div class="distribution-label">
                    <div class="box1"></div>
                    <label for="distribution-bar">Current Allocation</label>
                  </div>
                  <div class="distribution-label">
                    <div class="box2"></div>
                    <label for="distribution-bar">Desired Allocation</label>
                  </div>
                  <br />
                  <canvas
                    ref="myChart"
                    style="width: 100%; max-width: 600px"
                  ></canvas>
                </div>
                <br />
                <h2>Rebalancing action required</h2>
                <div id="action">
                  <div class="col-lg-12">
                    <div class="card second-card">
                      <form @submit.prevent="submitForm">
                        <div class="d-flex justify-content-between">
                          <div>Asset Class</div>
                          <div>Action Required</div>
                        </div>
                        <br />
                        <div class="rebalance-border">
                          <label for="total-investment">Equity</label>
                          <input
                            v-model="equityText"
                            id="total-investment"
                            class="rebalance-card-input"
                            readonly
                          />
                        </div>
                        <hr />
                        <div class="rebalance-border">
                          <label for="time-returns">Debt</label>
                          <input
                            v-model="debtText"
                            id="time-returns"
                            class="rebalance-card-input"
                            readonly
                          />
                        </div>
                        <hr />
                        <div class="rebalance-border">
                          <label for="total-returns">Gold</label>
                          <input
                            v-model="goldText"
                            id="total-returns"
                            class="rebalance-card-input"
                            readonly
                          />
                        </div>
                        <br />
                      </form>
                    </div>
                  </div>
                </div>
                <div
                  class="rebalance-calculator"
                  id="results"
                  style="background-color: #e6e6e9"
                ></div>
                <div class="row">
                  <div class="col-md-6"></div>
                  <div class="col-md-6">
                    <button
                      type="button"
                      @click="goToPage(1)"
                      class="rebalance-button"
                    >
                      Start Over
                    </button>
                  </div>
                </div>
              </div>
              <i class="rebalance-disclaim"
                >Disclaimer: Results shown for illustrative purpose only and
                should not be construed as investment advice</i
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js";

export default {
  name: "RebalanceCalculator",
  components: {},
  data() {
    return {
      formData: {
        equity: "",
        debt: "",
        gold: "",
        current: "",
        minValue: 0,
        maxValue: 100,
      },
      desiredEquityPercent: "",
      desiredDebtPercent: "",
      desiredGoldPercent: "",
      currentPage: 1,
      steps: ["Basic Details", "Results"],
      investmentBarColor: "#205AA6",
      investmentBarColors: "red",
      investmentBarColorss: "rose",
      xValues: ["Equity", "Debt", "Gold"],
      yValues: "",
      zValues: "",
      barColors: ["rgba(255,0,0,1.0)", "rose"],
      chart: null,
      freshInvest: 0,
      equityText: "",
      debtText: "",
      goldText: "",
      formSubmitted: false,
      msg: "",
      percentMsg: "",
      equityPer: "",
      debtPer: "",
      goldPer: "",
      reblanceThreshold: 5,
      showResults: false,
      thresMsg: "",
    };
  },
  computed: {
    anyFieldNotEmpty() {
      return (
        this.formData.equity !== "" ||
        this.formData.debt !== "" ||
        this.formData.gold !== ""
      );
    },
    totalAmount() {
      const equity = parseFloat(this.formData.equity) || "";
      const debt = parseFloat(this.formData.debt) || "";
      const gold = parseFloat(this.formData.gold) || "";
      return equity + debt + gold;
    },
    calculatedPercentages() {
      const equityAmount = parseFloat(this.formData.equity) || 0;
      const debtAmount = parseFloat(this.formData.debt) || 0;
      const goldAmount = parseFloat(this.formData.gold) || 0;

      let equityPer = "";
      let debtPer = "";
      let goldPer = "";

      if (
        !isNaN(equityAmount) ||
        !isNaN(debtAmount) ||
        !isNaN(goldAmount) ||
        this.totalAmount !== ""
      ) {
        equityPer = ((equityAmount / this.totalAmount) * 100).toFixed(2);
        debtPer = ((debtAmount / this.totalAmount) * 100).toFixed(2);
        goldPer = ((goldAmount / this.totalAmount) * 100).toFixed(2);
      }

      return {
        equityPer: equityPer,
        debtPer: debtPer,
        goldPer: goldPer,
        equityPerDisplay: equityPer !== "NaN" ? `${equityPer}%` : "0%",
        debtPerDisplay: debtPer !== "NaN" ? `${debtPer}%` : "0%",
        goldPerDisplay: goldPer !== "NaN" ? `${goldPer}%` : "0%",
      };
    },
  },
  mounted() {
    this.renderChart();
  },
  watch: {
    formData: {
      deep: true,
      handler() {
        this.renderChart();
      },
    },
  },
  methods: {
    submitForm() {
      this.formSubmitted = true;
      if (
        this.formData.equity == "" &&
        this.formData.debt == "" &&
        this.formData.gold == ""
      ) {
        this.msg = "Current investment cannot be empty";
        return;
      }
      const desiredEquityPercent = parseFloat(this.desiredEquityPercent) || 0;
      const desiredDebtPercent = parseFloat(this.desiredDebtPercent) || 0;
      const desiredGoldPercent = parseFloat(this.desiredGoldPercent) || 0;
      const totalDesiredPercent =
        desiredEquityPercent + desiredDebtPercent + desiredGoldPercent;
      if (
        totalDesiredPercent > 100 ||
        totalDesiredPercent < 100 ||
        totalDesiredPercent == 0
      ) {
        this.percentMsg = "Proposed allocation should add up to 100%";
        return;
      }

      this.currentPage++;
      this.renderChart();
      this.calculateTotalValue();
    },
    handleRebalanceThresholdChange() {
      const selectedThreshold = parseFloat(this.reblanceThreshold);
      if (selectedThreshold === 0) {
        this.thresMsg =
          "Rebalancing for small deviations may be sub-optimal for investment outcomes.";
      } else {
        this.thresMsg = "";
      }
    },
    goToPage(pageNumber) {
      this.currentPage = pageNumber;
    },

    decreaseReturns() {
      if (this.formData.inflation <= 3.5) {
        if (this.formData.inflation > 0) {
          this.formData.inflation = Math.max(this.formData.inflation - 0.5, 0);
        }
      } else {
        this.formData.inflation -= 1;
      }
    },
    increaseExpectedReturns() {
      if (this.formData.returns < 3.5) {
        this.formData.returns = Math.min(this.formData.returns + 0.5, 3.5);
      } else {
        if (this.formData.returns < 20) {
          this.formData.returns += 1;
        }
      }
    },
    renderChart() {
      const equityPercent = (
        ((parseFloat(this.formData.equity) || 0) / this.totalAmount) *
        100
      ).toFixed(2);
      const debtPercent = (
        ((parseFloat(this.formData.debt) || 0) / this.totalAmount) *
        100
      ).toFixed(2);
      const goldPercent = (
        ((parseFloat(this.formData.gold) || 0) / this.totalAmount) *
        100
      ).toFixed(2);

      this.yValues = [equityPercent, debtPercent, goldPercent];
      this.zValues = [
        this.desiredEquityPercent,
        this.desiredDebtPercent,
        this.desiredGoldPercent,
      ];

      const ctx = this.$refs.myChart.getContext("2d");

      if (this.chart) {
        this.chart.destroy();
      }

      this.chart = new Chart(ctx, {
        type: "horizontalBar",
        data: {
          labels: ["Equity", "Debt", "Gold"],
          datasets: [
            {
              label: "Current Allocation",
              backgroundColor: ["#205AA6", "#205AA6", "#205AA6"],
              data: this.yValues,
            },
            {
              label: "Desired Allocation",
              backgroundColor: ["#21D19F", "#21D19F", "#21D19F"],
              data: this.zValues,
            },
          ],
        },
        options: {
          legend: { display: false },
          scales: {
            xAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  callback: function (value) {
                    return value + "%";
                  },
                },
                gridLines: {
                  display: false,
                },
              },
            ],
          },
        },
      });
    },
    decreaseExpectedReturns() {
      if (this.formData.returns <= 3.5) {
        if (this.formData.returns > 0) {
          this.formData.returns = Math.max(this.formData.returns - 0.5, 0);
        }
      } else {
        this.formData.returns -= 1; // Decrease by 1 if inflation is above 3.5
      }
    },

    calculateTotalValue() {
      if (isNaN(this.formData.equity)) this.formData.equity = 0;
      if (isNaN(this.formData.debt)) this.formData.debt = 0;
      if (isNaN(this.formData.gold)) this.formData.gold = 0;
      if (isNaN(this.desiredEquityPercent)) this.desiredEquityPercent = 0;
      if (isNaN(this.desiredDebtPercent)) this.desiredDebtPercent = 0;
      if (isNaN(this.desiredGoldPercent)) this.desiredGoldPercent = 0;
      if (isNaN(this.freshInvest)) this.freshInvest = 0;
      const equity = this.formData.equity || 0;
      const debt = this.formData.debt || 0;
      const gold = this.formData.gold || 0;
      var curTotal = parseFloat(equity) + parseFloat(debt) + parseFloat(gold);
      let totalInvestments = curTotal + parseFloat(this.freshInvest);
      let desiredEquity =
        totalInvestments * parseFloat(this.desiredEquityPercent / 100);
      let desiredDebt =
        totalInvestments * parseFloat(this.desiredDebtPercent / 100);
      let desiredGold =
        totalInvestments * parseFloat(this.desiredGoldPercent / 100);
      let equityChange = desiredEquity - equity;
      let debtChange = desiredDebt - debt;
      let goldChange = desiredGold - gold;
      var curEPct = this.formData.equity / curTotal;
      var curDPct = this.formData.debt / curTotal;
      var curGPct = this.formData.gold / curTotal;
      console.log("This", +curEPct);
      var resultsArea = document.getElementById("results");
      var actionArea = document.getElementById("action");
      resultsArea.innerHTML = "Hello there!";

      var equityDev = Math.abs(curEPct * 100 - this.desiredEquityPercent);
      var debtDev = Math.abs(curDPct * 100 - this.desiredDebtPercent);
      var goldDev = Math.abs(curGPct * 100 - this.desiredGoldPercent);

      if (
        equityDev < parseFloat(this.reblanceThreshold) &&
        debtDev < parseFloat(this.reblanceThreshold) &&
        goldDev < parseFloat(this.reblanceThreshold)
      ) {
        actionArea.classList.remove("d-block");
        actionArea.classList.add("d-none");
        resultsArea.classList.remove("d-none");
        resultsArea.classList.add("d-block");
        let message =
          "<p>The rebalance threshold provided is " +
          this.reblanceThreshold +
          "%. The current value of asset classes do not deviate beyond this threshold presently. Hence, no rebalancing is required.</p>";
        resultsArea.innerHTML = message;
        return false;
      } else {
        actionArea.classList.remove("d-none");
        actionArea.classList.add("d-block");
        resultsArea.classList.remove("d-block");
        resultsArea.classList.add("d-none");
      }
      if (equityChange < 0) {
        this.equityText =
          "Redeem " +
          Intl.NumberFormat("en-IN", {
            style: "currency",
            currency: "INR",
          }).format(Math.abs(equityChange));
      } else if (equityChange > 0) {
        this.equityText =
          "Invest " +
          Intl.NumberFormat("en-IN", {
            style: "currency",
            currency: "INR",
          }).format(Math.abs(equityChange));
      } else if (equityChange == 0) {
        this.equityText = "No change required";
      }

      if (debtChange < 0) {
        this.debtText =
          "Redeem " +
          Intl.NumberFormat("en-IN", {
            style: "currency",
            currency: "INR",
          }).format(Math.abs(debtChange));
      } else if (debtChange > 0) {
        this.debtText =
          "Invest " +
          Intl.NumberFormat("en-IN", {
            style: "currency",
            currency: "INR",
          }).format(Math.abs(debtChange));
      } else if (debtChange == 0) {
        this.debtText = "No change required";
      }

      if (goldChange < 0) {
        this.goldText =
          "Redeem " +
          Intl.NumberFormat("en-IN", {
            style: "currency",
            currency: "INR",
          }).format(Math.abs(goldChange));
      } else if (goldChange > 0) {
        this.goldText =
          "Invest " +
          Intl.NumberFormat("en-IN", {
            style: "currency",
            currency: "INR",
          }).format(Math.abs(goldChange));
      } else if (goldChange == 0) {
        this.goldText = "No change required";
      }
    },

    increaseTimePeriod() {
      if (this.formData.time < 50) {
        this.formData.time++;
      }
    },
    decreaseTimePeriod() {
      if (this.formData.time > 1) {
        this.formData.time--;
      }
    },
  },
};
</script>

<style scoped>
.step-indicator-container {
  margin-top: 10px;
}

.step-button {
  padding: 10px 20px;
  border-radius: 5px;
  background-color: #f2f2f2;
  color: #012e40 !important;
}
.rebalance-calculator .rebalance-input label {
  display: block;
  font-weight: bold;
  text-align: justify;
  font-size: 16px;
  color: #012e40 !important;
}

.rebalance-input input {
  text-align: justify;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  background: transparent;
}

.rebalance-group {
  display: flex;
  border: 1px solid #e5e5e5;
  margin: 0 0 10px;
  border-radius: 8px;
  -ms-flex-align: center;
  align-items: center;
}

.rebalance-border {
  border: none;
  outline: none;
  background: none;
}

.label-spacing {
  margin-bottom: 0.7rem;
}

.rebalance-calculator {
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.1);
  padding: 4%;
}

.first-card {
  border: none !important;
  border-radius: 10px;
  background-color: #f8f9fa;
  margin-top: 19px;
  padding: 10px;
}

.second-card {
  border: none !important;
  border-radius: 10px;
  background-color: #f8f9fa;
  padding: inherit;
}

.second-card input {
  text-align: right;
  float: right;
  outline: none;
}

.rebalance-card-input {
  text-align: center;
  border: none;
  outline: none;
  background: transparent;
}

.rupees-symbol {
  display: flex;
  font-size: 14px;
  color: #555;
  margin: 5px;
}

.rebalance-thres {
  font-size: 80%;
  color: red;
}

.distribution-label {
  display: inline-flex;
  align-items: center;
  margin-bottom: 10px;
  margin-right: 5px;
}

.distribution-label .box1 {
  width: 30px;
  height: 10px;
  background-color: #205aa6;
  margin-right: 10px;
}

.distribution-label .box2 {
  width: 30px;
  height: 10px;
  background-color: #21d19f;
  margin-right: 10px;
}

.distribution-label .box3 {
  width: 146px;
  height: 10px;
  background-color: #f2f230;
  margin-right: 10px;
}

.color-bar {
  width: 100%;
  height: 20px;
  margin-bottom: 5px;
  position: relative;
  background-color: #205aa6;
}

.bar-invest {
  height: 100%;
  position: absolute;
  top: 0;
}

.bar-values {
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-size: 12px;
}

.validate-msg {
  color: #dd2e44;
  position: relative;
  bottom: 17px;
  font-size: 12px;
}

.rebalance-button {
  width: 100%;
  background: #00a3d9;
  color: white;
  padding: 0.5em;
  margin: 0px 0 75px;
  border-radius: 5px;
}

.rebalance-disclaim {
  color: #918d99;
  font-size: 14px;
  margin-bottom: 1%;
  margin-top: -10%;
}
</style>
